import { createApi } from '@reduxjs/toolkit/query/react';
import { RecordResponse } from '../models/ServiceTypes';
import { waServicesQuery } from './baseQueries';

/** Identifying fields returned by GET /api/TeamMember/Advisors for every firm. */
export interface TeamMemberAdvisor {
  AdvisorId: number;
  Name: string;
  UserId?: number;
}

/**
 * Returned instead of the base shape when the firm has the
 * `FirmAdvisors`/`ShowTeamMemberSummed` permission, which adds the summed stats.
 */
export interface TeamMemberAdvisorSummed extends TeamMemberAdvisor {
  SummedAUM: number;
  SummedHeldAway: number;
  SummedNumberOfManagedAccounts: number;
  SummedNumberOfClients: number;
  SummedNumberOfActiveClients: number;
  IsAdminLocked?: boolean;
}

/** A row of GET /api/TeamMember/Advisors: base or summed depending on permission. */
export type TeamMemberAdvisorRecord =
  | TeamMemberAdvisor
  | TeamMemberAdvisorSummed;

/**
 * The API is all-or-nothing per firm: either every record carries the summed
 * fields or none do, so checking a single summed field is enough.
 */
export const isSummedAdvisor = (
  advisor: TeamMemberAdvisorRecord,
): advisor is TeamMemberAdvisorSummed => 'SummedAUM' in advisor;

export const teamMemberApi = createApi({
  reducerPath: 'teamMemberApi',
  baseQuery: waServicesQuery,
  endpoints: (builder) => ({
    getTeamMemberAdvisors: builder.query<
      RecordResponse<TeamMemberAdvisorRecord>,
      undefined
    >({
      query: () => ({
        url: `/api/TeamMember/Advisors`,
        method: 'GET',
      }),
    }),
  }),
});

export const { useGetTeamMemberAdvisorsQuery } = teamMemberApi;
